module.exports = __webpack_public_path__ + "static/media/vip-trophy-1.1df0293c.png";